import { get } from 'lodash';
import { removeEmpty } from '../../actions/utils';
import { instance, loadInstance } from './api.service';

export const getRoute = async (id) => {
  const resp = await instance.get(`/route/${id}`, { data: {} });
  return get(resp, 'data.route', null);
};

export const getRoutes = async (where, opts = {}) => {
  opts = {
    useExternal: false,
    ...opts,
  }
  let resp = {};
  const inst = loadInstance(opts)
  if (where) {
    resp = await inst.post(`/routes`, {
      where,
    });
  } else {
    resp = await inst.get(`/routes`, { data: {} });
  }
  return get(resp, 'data.routes', []);
};

export const createRoute = async (route) => {
  const resp = await instance.post('/routes/create', {
    route,
  });
  return get(resp, 'data.route', null);
};

export const updateRoute = async (route) => {
  const resp = await instance.post('/routes/update', {
    route: removeEmpty(route),
  });
  return get(resp, 'data.route', null);
};

export const deleteRoute = async (route) => {
  const resp = await instance.post('/routes/delete', {
    route: removeEmpty(route),
  });
  return get(resp, 'data.route', null);
};

export const copyRouteRows = async (sourceId, targetId) => {
  const resp = await instance.post('/routes/copyrows', {
    sourceId,
    targetId,
  });
  return get(resp, 'data', {});
};

export const findRoutesFromZip = async (zip, opts = {}) => {
  const inst = loadInstance(opts);

  const resp = await inst.post('/routes/find', {
    zip,
  })
  
  return get(resp, 'data.routes', []);
}